import { useFormik } from "formik";
import * as Yup from "yup";
import AscModal from "../AscModal/AscModal";
import styles from "./AscModalUpdateCertificate.module.scss";
import AscTextInput from "../AscInputFields/AscTextInput/AscTextInput";
import AscButton from "../AscButton/AscButton";
import AscHeading from "../AscTypography/AscHeading/AscHeading";
import AscParagraph from "../AscTypography/AscParagraph/AscParagraph";

interface AscModalUpdateCertificateProps {
  fullname?: string;
  handleUpdate: ({ name }: { name: string }) => void;
  visible: boolean;
  setVisible: (a: boolean) => void;
}

function AscModalUpdateCertificate({
  fullname,
  handleUpdate,
  visible,
  setVisible,
}: AscModalUpdateCertificateProps) {
  const formik = useFormik({
    initialValues: { name: fullname || "" },
    validationSchema: Yup.object({
      name: Yup.string()
        .min(3, "At least 3 characters")
        .required("Name is required"),
    }),
    onSubmit: (values) => handleUpdate({ name: values.name }),
  });

  return (
    <AscModal
      visible={visible}
      setVisible={setVisible}
      modalClassName={styles.modal}
      withBackground={false}
      onClose={() => formik.setValues({ name: "" })}
      header={<AscHeading level={5}>Update your certificate</AscHeading>}
    >
      <form onSubmit={formik.handleSubmit} className={styles.ground}>
        <AscParagraph className={styles.subtitle}>
          Please add or review your name and then we’ll update your certificate.
        </AscParagraph>
        <div className={styles.fieldGroup}>
          <label className={styles.fieldLabel}>Name</label>
          <AscTextInput
            name="name"
            placeholder="Enter your full name..."
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            value={formik.values.name}
            className={styles.fieldInput}
          />
        </div>
        <div className={styles.footer}>
          <AscButton variant="secondary" onClick={() => setVisible(false)}>
            Cancel
          </AscButton>
          <AscButton type="submit" variant="primary">
            Update
          </AscButton>
        </div>
      </form>
    </AscModal>
  );
}

export default AscModalUpdateCertificate;
